import * as yup from 'yup';
import { validateObject, validateObject2 } from './functions';

export const validationForm1 = yup.object().shape({
  //workingPlace
  codeInep: yup.number().required(' preencha o cep').typeError(' preencha o campo com numeros').min(9, " informe o cep completo"),
  workingSituation: yup.number().required('Selecione uma das opções').moreThan(0, 'Selecione uma das opções'),
  startDate: yup.date().when('workingSituation', {
    is: (value) => value === '1',
    then: yup.date().required(' informe a data inicial').typeError(' informe a data inicial'),
  }).nullable(),
  finishDate: yup.date().when('workingSituation', {
    is: (value) => value === '1',
    then: yup.date().required(': informe a data final').typeError(': informe a data final'),
  }).nullable(),
  name: yup.string().min(4, ' informe no minimo 4 caracteres').max(100, ' o  aceita no maximo 100 caracteres'),
  city: yup.string().nullable(),
  cep: yup.string().when('city', {
    is: (value) => {
      if (value === null) {
        return true
      }
      return false

    },
    then: yup.string().required(' preencha o cep').typeError(' preencha o campo com numeros').min(9, " informe um cep valido")
  }).required(' preencha o cep').min(9, " informe o cep completo"),
  district: yup.string().required(': informe o distrito').min(1, ': informe o distrito'),
  publicPlace: yup.string().required(' informe o endereço').min(1, ' informe a endereço'),
  number: yup.string(),
  complement: yup.string(),
  neighborhood: yup.string(),
  // telephone: yup.string(),
  telephone: yup
    .string()
    .required('O telefone é obrigatório')
    .test('valid-telephone', function (value) {
      if (!value) return false;

      const digits = value.replace(/\D/g, '');

      if (digits.length === 9 && !digits.startsWith('9')) {
        return this.createError({
          message: 'informe um numero válido 9xxxx-xxxx'
        });
      }

      if (digits.length === 8 && digits.startsWith('9')) {
        return this.createError({
          message: 'informe um numero válido 9xxxx-xxxx (acrescentar o 9 no inicio).'
        });
      }

      if (digits.length !== 8 && digits.length !== 9) {
        return this.createError({
          message: 'O número deve conter 8 digito para telefone fixo ou 9 dígitos para celular.'
        });
      }

      return true;
    }),
  ddd: yup.number().when('telephone', {
    is: (value) => {
      if (value.length > 0) {
        return true
      }
      else {
        return false
      }
    },
    then: yup.number().moreThan(0, ' selecione o DDD')
  }).nullable(),
  email: yup.string(),
  codeTeachingBody: yup.string().max(5, ' informe no máximo 5 digitos'),
  schoolZone: yup.number().required(' informe a localização da escola').moreThan(0, ' informe a zona de localização da escola'),
  localizationSchool: yup.number().required(' informe a localização da escola').moreThan(0, " informe a localização da escola"),
  administrativeDependency: yup.number().required(' Selecione uma das opções').moreThan(0, ' Selecione uma das opções'),
  linkedInstitutions: yup.array().when('administrativeDependency', {
    is: (value) => value !== 4,
    then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
      return validateObject(value);
    })
  }).nullable(),
  partnerPublicPowers: yup.array().when('workingSituation', {
    is: 1,
    then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
      return validateObject(value);
    })
  }).nullable(),
  formContractingPartnershipStateDepartmentEducation: yup.array().when('partnerPublicPowers', {
    is: (value) => {
      if (value === null) {
        return false
      }
      else {
        let cont = 0
        for (let i = 0; i < value.length; i++) {
          if (value[i] === 1 || value[i] === '1') {
            cont = 1
          }
        }
        if (cont !== 0) {
          return true
        } else {
          return false
        }
      }
    },
    then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
      return validateObject(value, 'estadual');
    }).required(' selecione pelo menos uma opção')
  }).nullable(),
  formContractingPartnershipMunicipalDepartmentEducation: yup.array().when('partnerPublicPowers', {
    is: (value) => {
      if (value === null) {
        return false
      }
      else {
        let cont = 0
        for (let i = 0; i < value.length; i++) {
          if (Number(value[i]) === 2) {
            cont = 1
          }

        }
        if (cont !== 0) {
          return true
        } else {
          return false
        }
      }
    },
    then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
      return validateObject(value, 'estadual');
    }).required(' selecione pelo menos uma opção')
  }).nullable(),
  privateSchoolMaintainers: yup.array().when('administrativeDependency', {
    is: (value) => value === 4,
    then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
      return validateObject(value);
    })
  }).nullable(),
  privateSchoolCategory: yup.string().when('administrativeDependency', {
    is: 4,
    then: yup.string().required('selecione uma opção')
  }),
  regulation: yup.number().when('workingSituation', {
    is: 1,
    then: yup.number().typeError('selecione pelo menos uma opção').required('selecione pelo menos uma opção'),
  }).nullable(),
  spheresRegulatoryInstitution: yup.array().when('regulation', {
    is: (value) => value !== null,
    then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
      return validateObject(value);
    })
  }).nullable(),
  cnpjMaintainer: yup.string().when('privateSchoolCategory', {
    is: 1,
    then: yup.string().required(' selecione pelo menos uma opção')
  }).nullable(),
  // cnpj: yup.string().when('privateSchoolCategory', {
  //   is: 1,
  //   then: yup.string().required(' selecione pelo menos uma opção')
  // }).nullable(),
  cnpj: yup.string(),
  bindingUnit: yup.number().when('workingSituation', {
    is: 1,
    then: yup.number().typeError(' selecione pelo menos uma opção').required(' selecione pelo menos uma opção'),
  }).nullable(),
  codeSchoolHeadquarters: yup.string().when('bindingUnit', {
    is: 1,
    then: yup.string().required(': selecione pelo menos uma opção')
  }).nullable(),
})

export const validationForm2 = yup.object().shape({

  workingPlace: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject2(value);
  }),
  //

  formOccupation: yup.number().when('workingPlace', {
    is: (value) => {
      if (value !== null) {

        for (let w = 0; w < value.length; w++) {
          if (value[w] === "predioEscolar") {
            return true;
          }
        }
      }
      return false;
    },
    then: yup.number().required(' selecione uma opção')
  }),
  sharedBuilding: yup.number().when('workingPlace', {
    is: (value) => {
      if (value !== null) {
        for (let w = 0; w < value.length; w++) {
          if (value[w] === "predioEscolar") {
            return true;
          }
        }
      }
      return false;
    },
    then: yup.number().required(' selecione uma opção').moreThan(-1, ' selecione uma opção')
  }).nullable(),
  //sharedCodeSchool falta esse
  codeSchool: yup.number(),
  //
  haveDrinkingWater: yup.number().required(' selecione uma opção').moreThan(-1, ' selecione uma opção'),

  waterSupply: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject(value);
  }),
  powerSupply: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject(value);
  }),

  //
  sanitarySewage: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject(value);
  }),
  garbageDisposal: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject(value);
  }),
  wasteTreatment: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject(value);
  }),
  existingPhysicalDependencies: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject(value);
  }),
  accessibilityFeatures: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject(value);
  }),
  numberIndoorRooms: yup.number().when('workingPlace', {
    is: (value) => {
      if (value !== null) {
        for (let w = 0; w < value.length; w++) {
          if (value[w] === "predioEscolar") {
            return true;
          }
        }
      }
      return false;
    },
    then: yup.number().required(' informe a quantidade de salas').typeError(' informe a quantidade de salas').moreThan(0, ' informe a quantidade de salas')
  }).nullable(),
  numberRoomsOutside: yup.number().when('workingPlace', {
    is: (value) => {
      if (value !== null) {
        for (let w = 0; w < value.length; w++) {
          if (value[w] === "outra Escola") {
            return true;
          }
        }
      }
      return false;
    },
    then: yup.number().required(' informe a quantidade de salas fora do predio').typeError(' informe a quantidade de salas fora do predio').moreThan(0, ' informe a quantidade de salas fora do predio')
  }).nullable().default(0).typeError(' digite 0 para nenhum valor'),
  numberChildEducationRooms: yup
    .number()
    .min(0, 'Número inválido')
    .required('Informe o número de salas com ar condicionado')
    .test(
      'max-airconditioned',
      'O número de Quantidade de salas de aula com Cantinho da Leitura para a Educação Infantil não pode ser maior que a soma das salas usadas dentro e fora do prédio',
      function (value) {
        const { numberIndoorRooms, numberRoomsOutside } = this.parent;
        if (value == null) return false;
        const totalRooms = (numberIndoorRooms || 0) + (numberRoomsOutside || 0);

        return value <= totalRooms;
      }
    ),
  numberAirconditionedRooms: yup
    .number()
    .min(0, 'Número inválido')
    .required('Informe o número de salas com ar condicionado')
    .test(
      'max-airconditioned',
      'O número de salas com ar condicionado não pode ser maior que a soma das salas usadas dentro e fora do prédio',
      function (value) {
        const { numberIndoorRooms, numberRoomsOutside } = this.parent;
        if (value == null) return false;
        const totalRooms = (numberIndoorRooms || 0) + (numberRoomsOutside || 0);

        return value <= totalRooms;
      }
    ),
   numberAccessibleRooms: yup
    .string()
    .nullable()
    .transform((v, o) => (o === '' ? null : v))
    // até 4 dígitos numéricos
    .matches(/^\d{1,4}$/, 'Informe até 4 dígitos numéricos')
    .test('required-if-rooms-filled', 'Preenchimento obrigatório se salas usadas estiverem preenchidas', function (value) {
      const { numberIndoorRooms, numberRoomsOutside } = this.parent;
      if ((numberIndoorRooms != null || numberRoomsOutside != null) && (value == null || value === '')) {
        return false;
      }
      return true;
    })
    .test('max-sum-rooms', 'Valor não pode ser maior que a soma dos campos 90 e 91', function (value) {
      if (!value) return true;
      const accessibleNumber = parseInt(value, 10);
      const { numberIndoorRooms, numberRoomsOutside } = this.parent;
      const totalRooms = (numberIndoorRooms || 0) + (numberRoomsOutside || 0);
      return accessibleNumber <= totalRooms;
    }),
  // yup.number().when('workingPlace', {
  //   is: (value) => value !== "predioEscola",
  //   then: yup.number().required('selecione uma opção')
  // }),
  administrativeTechnicians: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject(value);
  }),
  teachingLearning: yup.array().test('at-least-one-attribute', ' informe pelo menos um dos campos', value => {
    return validateObject2(value);
  }),

  //
  broadbandInternet: yup.number().required(' selecione uma opção').moreThan(-1, ' selecione uma opção'),
  accessInternet: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject(value);
  }),
  equipmentUsedAccessInternet: yup.array().when('accessInternet', {
    is: (value) => value === "aluno",
    then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
      return validateObject(value);
    })
  }).nullable(),

  pcStudents: yup.array().when('equipmentUsedAccessInternet', {
    is: (value) => value === "1",
    then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
      return validateObject(value);
    })
  }).nullable(),
  //
  localComputerNetwork: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject(value);
  }),
  //totalProfessionals
  totalProfessionals: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject2(value);
  }),
  //
  schoolFood: yup.number().required('selecione uma opção').moreThan(-1, ' selecione uma opção'),
})

export const validationForm3 = yup.object().shape({
  learningInstrumentsMaterial: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject(value);
  }),
  indigenousSchool: yup.number().required(" selecione uma opção de Escola indígena").moreThan(-1, " selecione uma opção de Escola indígena"),
  languageTeaching: yup.array().when('indigenousSchool', {
    is: (value) => value === 1,
    then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
      return validateObject(value);
    }),
  }).nullable(),
  //
  indigenousLanguageCode: yup.array().when('languageTeaching', {
    is: (value) => {
      if (value === null) {
        return false
      }
      else {
        for (let i = 0; i < value.length; i++) {
          if (value[i] === 'ID') {
            return true
          } else {
            return false
          }
        }
      }
    },
    then: yup.array().test('at-least-one-attribute', ' informe pelo menos uma opção da lingua indígena ', value => {
      return validateObject2(value);
    }),
  }).nullable(),
  //
  haveSelectionExam: yup.number().moreThan(-1, ' selecione uma opção'),
  quotaSystemReservation: yup.array().when('haveSelectionExam', {
    is: (value) => value === 1,
    then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
      return validateObject(value);
    }),
  }).nullable(),
  //
  haveSite: yup.number(),
  shareSpaceIntegrationCommunity: yup.number(),
  useSurroundingSpacesEquipment: yup.number(),

  collegiateBodies: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
    return validateObject(value);
  }),
  pedagogicalProjectProposal: yup.number().moreThan(-1, ''),
  hasDevelopmentEnvironmentalEducation: yup.number().required(" selecione uma opção").moreThan(-1, " selecione uma opção"),
  formsEnvironmentalEducation: yup.array().when('hasDevelopmentEnvironmentalEducation', {
    is: (value) => value === 1,
    then: yup.array().test('at-least-one-attribute', ' selecione pelo menos uma opção', value => {
      return validateObject(value);
    }),
  }).nullable(),
})